<div class="hora-pass" [nbSpinner]="loading() || saving()">
  <wr-banner status="info"
             [icon]="{ icon: 'info-outline', pack: 'eva' }"
             message="Der HORA-Pass wird beim Generieren an die Downloads angehängt, die in der Firma unter „Downloads“ markiert sind. Bereits generierte Dokumente bleiben unverändert.">
  </wr-banner>

  @let current = horaPass();
  @if (current) {
    <div class="hora-pass-file">
      <nb-icon icon="file-text-outline" pack="eva"></nb-icon>
      <a [href]="current.presignedUrl" target="_blank" rel="noopener">{{ current.fileName || 'HORA-Pass.pdf' }}</a>
      <span class="created">{{ current.created | date: 'dd.MM.yyyy' }}</span>
    </div>
  } @else if (!loading()) {
    <p class="empty">Für dieses Gebäude ist kein HORA-Pass hinterlegt.</p>
  }

  @if (canEdit()) {
    <div class="actions">
      <input #fileInput type="file" accept="application/pdf,.pdf" hidden (change)="onFileSelected($event)">
      <button nbButton outline status="info" size="small" [disabled]="saving()" (click)="fileInput.click()">
        {{ current ? 'Ersetzen' : 'Hochladen' }}
      </button>
      @if (current) {
        <button nbButton outline status="danger" size="small" [disabled]="saving()" (click)="deleteHoraPass()">
          Löschen
        </button>
      }
    </div>
  }
</div>
